// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import skillVersionEntity from './entities/skill-version.json';
import skillVersionMenu from '../pages/skill-version/menu.json';
import skillVersionFullForm from '../pages/skill-version/forms/full.json';
import skillVersionContextForm from '../pages/skill-version/forms/context.json';
import skillVersionMiniForm from '../pages/skill-version/forms/mini.json';
import skillVersionLookupForm from '../pages/skill-version/forms/lookup.json';
import skillVersionTableView from '../pages/skill-version/views/table.json';
import skillVersionCardsView from '../pages/skill-version/views/cards.json';
import skillVersionDashboardView from '../pages/skill-version/views/dashboard.json';

/** Тип запису «Версія навички» зі сторінками пакета: меню, форми та подання з pages/skill-version/. */
export const skillVersionDefinition: IRecordTypeDefinition = {
  ...skillVersionEntity,
  views: assembleViewSet({
      table: skillVersionTableView,
      cards: skillVersionCardsView,
      dashboard: skillVersionDashboardView,
  }),
  form: skillVersionFullForm,
  forms: { full: skillVersionFullForm, context: skillVersionContextForm, mini: skillVersionMiniForm, lookup: skillVersionLookupForm },
  menu: skillVersionMenu,
} as IRecordTypeDefinition;
